import styled, { css } from 'styled-components';

import Pagination from 'Components/Pagination';

export const List = styled.ul`
    ${({ theme }) => css`
        list-style: none;
        display: grid;
        gap: 1rem;
        padding: 0;
        grid-template-columns: 1fr;

        @media ${theme.breakpoints.medium.media} {
            grid-template-columns: repeat(2, 1fr);
        }

        @media ${theme.breakpoints.colossal.media} {
            gap: 1.5rem;
        }
    `}
`;

export const ListItem = styled.li`
    margin: 0;
`;

export const NoResults = styled.div`
    font-weight: 600;
    padding: 2rem 0.5rem;
    font-size: 1.25rem;
    grid-column: span 12;

    @media ${({ theme }) => theme.breakpoints.large.media} {
        font-size: 1.5rem;
    }
`;

export const PaginationWrapper = styled.div`
    ${({ theme }) => css`
        padding: 1rem 0 0.5rem;
        text-align: center;

        @media ${theme.breakpoints.medium.media} {
            padding: 2rem 0 1.5rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            padding: 3rem 0 1rem;
        }
    `}
`;

export const StyledPagination = styled(Pagination)`
    ${({ theme }) => css`
        background: ${theme.colors.secondary.hex};
        border-color: ${theme.colors.secondary.tints[2].hex};
    `}
`;
